export default __webpack_public_path__ + "static/media/KillerPolyester1.aaeeb5b0.jpg";